// Skeleton Components
const SkeletonInput = ({ labelWidth = "120px", className = "" }) => (
  <div className={`skeleton-input ${className}`}>
    <div
      className="skeleton-label mb-2"
      style={{
        width: labelWidth,
        height: "16px",
        background: "#f0f0f0",
        borderRadius: "4px",
      }}
    ></div>
    <div
      className="skeleton-field"
      style={{
        width: "100%",
        height: "40px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    ></div>
  </div>
);

const SkeletonImageUpload = () => (
  <div className="col-12 col-sm-4 mb-3">
    <div className="skeleton-image-upload">
      <div
        className="skeleton-image"
        style={{
          width: "100%",
          height: "150px",
          background: "#f0f0f0",
          borderRadius: "8px",
          marginBottom: "10px",
        }}
      ></div>
      <div
        className="skeleton-text"
        style={{
          width: "80%",
          height: "16px",
          background: "#f0f0f0",
          borderRadius: "4px",
          margin: "0 auto",
        }}
      ></div>
    </div>
  </div>
);

const AddVehicleSkelton = () => {
  return (
    <div className="form-skeleton">
      {/* Image Upload Skeleton */}
      <div className="row mb-4">
        <SkeletonImageUpload />
        <SkeletonImageUpload />
        <SkeletonImageUpload />
      </div>

      {/* Form Inputs Skeleton */}
      <div className="row mb-4">
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="120px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="80px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="80px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="80px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="80px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="60px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="140px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="60px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="100px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="100px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="100px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="100px" />
        </div>
      </div>

      {/* Document Upload Skeleton */}
      <div className="row mb-4">
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="150px" />
        </div>
        <div className="col-12 col-md-4 col-lg-3 mb-3">
          <SkeletonInput labelWidth="150px" />
        </div>
      </div>

      {/* Description Skeleton */}
      <div className="mb-4">
        <div
          className="skeleton-label mb-2"
          style={{
            width: "150px",
            height: "16px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
        <div
          className="skeleton-field"
          style={{
            width: "100%",
            height: "100px",
            background: "#f0f0f0",
            borderRadius: "6px",
          }}
        ></div>
      </div>

      {/* Button Skeleton */}
      <div className="pt-4 mt-3 border-top text-end">
        <div
          className="skeleton-button d-inline-block me-3"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
        <div
          className="skeleton-button d-inline-block"
          style={{
            width: "100px",
            height: "40px",
            background: "#f0f0f0",
            borderRadius: "4px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default AddVehicleSkelton;
